import { Box, StatusToast, ToastContainer } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { FC } from 'react';
import s from '../ClientProjects.module.scss';

type Props = {
  isMobileView?: boolean;
  onDismiss: () => void;
};

const ProjectErrorToast: FC<Props> = ({ isMobileView, onDismiss }) => {
  const { t } = useTranslation();
  const sidePadding = isMobileView ? '12px' : '';

  return (
    <ToastContainer>
      <Box paddingLeft={sidePadding} paddingRight={sidePadding}>
        <StatusToast
          key="project-error-toast"
          status="error"
          dataHook="project-modal-open-error-notification"
          duration={8000}
          dismissible={true}
          onDismiss={onDismiss}
          className={isMobileView ? s.errorToastMobile : s.errorToast}
        >
          {t('profile-page-project-modal-issue')}
        </StatusToast>
      </Box>
    </ToastContainer>
  );
};

export default ProjectErrorToast;
